import React from 'react';

interface LoadingIconProps {
  size?: number;
  color?: string;
}

const LoadingIcon: React.FC<LoadingIconProps> = ({
  size = 50,
  color = '#3498db',
}) => {
  const iconStyle = {
    width: size,
    height: size,
    border: '5px solid #f3f3f3',
    borderTop: `5px solid ${color}`,
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
  };

  return <div style={iconStyle}></div>;
};

export default LoadingIcon;
